export default __webpack_public_path__ + "static/ico-uczenie-ff950c94257d0931b50a8f6634769e85.svg";